import { Link } from 'react-router-dom';

const NavPillLink = ({ to, icon: Icon, label, isActive = false }) => {
	return (
		<Link
			to={to}
			className={`flex items-center gap-1.5 px-4 py-2 rounded-full !text-sm !font-semibold !no-underline transition-colors sub-nav-items !text-investor-deep ${
				isActive
					? 'bg-investor-green'
					: 'hover:bg-investor-mint/20'
			}`}>
			{Icon && <Icon className="!text-[18px]" />}
			<span className="uppercase">{label}</span>
		</Link>
	);
};

export default NavPillLink;
